import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Button, Form, InputGroup, Badge, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown, faChevronLeft, faChevronRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import MyCarousel from "./Carousel";
import HeroSection from "./Hero";
import LoadingSpinner from "./LoadingSpinner";
import './PokemonBinder.css';
import './carousel.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



function getInitialScreenSize() {
  const width = window.innerWidth;
  if (width < 768) {
    return 1; // Mobile screen
  } else if (width >= 768 && width < 992) {
    return 2; // Medium screen
  } else {
    return 3; // Large screen
  }
}



const PokemonBinder = ({ collection }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [numberofitems , setNumberofitems] = useState(0);
  const [totalcost , setTotalcost] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength).trim() + '...';
    }
    return text;
  };

  // Render the truncated header if the screen size is small
  const renderCardHeader = (header) => {
    if (screenSize === 1) { // Mobile screen
      return <div className="card-header">{truncateText(header, 5)}</div>;
    }
    else if (screenSize === 2) { // Mobile screen
      return <div className="card-header">{truncateText(header, 10)}</div>;
    }
    return <div className="card-header">{header}</div>;
  };

  const [orderby, setOrderby] = useState('name');
  const [sortOrder, setSortOrder] = useState("asc");


  const handleOrderBy = (key) => {
    if (key === orderby && sortOrder === "asc") {
      setSortOrder("desc");
    } else {
      setSortOrder("asc");
    }
    setOrderby(key);
  };


  const [children, setData] = useState([]);
  
  function fetchData() {
    setLoading(true);
    const url = "images/collection_staged.json";
    axios.get(url)
      .then(response => {
        var jsonObj = []; var filteredObj = [];
        try {
          jsonObj = JSON.parse(response.data);
        }
        catch (error) {
          console.error('Failed to parse JSON response:', error);
          jsonObj = response.data;
        }
        setNumberofitems(0);
        let total = 0; // Initialize total variable
        for (var item in jsonObj) {
          if (jsonObj[item].collection === collection) {
            filteredObj.push(jsonObj[item]);
            setNumberofitems(prevNumber => prevNumber + 1);
            total += Number(jsonObj[item]['price']); // Accumulate prices
          }
        }
        setTotalcost(total);

        filteredObj.sort((a, b) => {
          const valueA = a[orderby];
          const valueB = b[orderby];
        
          // Check if the values are integers
          const isValueAInteger = Number.isInteger(parseInt(valueA));
          const isValueBInteger = Number.isInteger(parseInt(valueB));
        
          if (isValueAInteger && isValueBInteger) {
            // Both values are integers
            return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
          } else if (isValueAInteger) {
            // Only valueA is an integer, so it should be sorted before valueB
            return sortOrder === "asc" ? -1 : 1;
          } else if (isValueBInteger) {
            // Only valueB is an integer, so it should be sorted before valueA
            return sortOrder === "asc" ? 1 : -1;
          } else {
            // None of the values are integers, perform a locale-based string comparison
            if (sortOrder === "asc") {
              return valueA.localeCompare(valueB);
            } else {
              return valueB.localeCompare(valueA);
            }
          }
        });
        
        


        setCurrentPage(0);
        setData(filteredObj);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch collection data:', error);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchData();
  }, [collection, orderby, sortOrder, numberofitems, totalcost]);



  const handleClick = (input1, input2) => {
    navigate('/' + input2 + '/' + input1);
  };


  // check current page
  const [currentPage, setCurrentPage] = useState(0);

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const [screenSize, setScreenSize] = useState(getInitialScreenSize());

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    if (width < 768) {
      setScreenSize(1); // Mobile screen
    } else if (width >= 768 && width < 992) {
      setScreenSize(2); // Medium screen
    } else {
      setScreenSize(3); // Large screen
    }
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  // Filter items based on search term
  const filteredChildren = children.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getSortIcon = () => {
    if (sortOrder === 'asc') return faSortUp;
    if (sortOrder === 'desc') return faSortDown;
    return faSort;
  };

  if (loading) {
    return (
      <Container className="pokemon-binder">
        <HeroSection />
        <LoadingSpinner size="large" message="Loading your collection..." />
      </Container>
    );
  }

  return (
    <Container className="pokemon-binder">
      <HeroSection />
      <MyCarousel show={screenSize} collection={collection} />
      
      <div className="page-wrapper">
        <div className="page">
          <div className="collection-header">
            <h2 className="collection-title">
              {collection.charAt(0).toUpperCase() + collection.slice(1)} Collection
            </h2>
            <div className="collection-stats">
              <div className="collection-stat">
                <span className="collection-stat-number">{numberofitems}</span>
                <span className="collection-stat-label">Items</span>
              </div>
              <div className="collection-stat">
                <span className="collection-stat-number">£{totalcost}</span>
                <span className="collection-stat-label">Total Value</span>
              </div>
            </div>
          </div>

          {/* Search Bar */}
          <Row className="mb-4">
            <Col lg={6} className="mx-auto">
              <div className="search-container">
                <InputGroup size="lg">
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search your collection..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>

          {/* Controls Section */}
          <div className="controls-section">
            <h3>Sort & Filter</h3>
            <Row className="align-items-center">
              <Col lg={8}>
                <div className="sort-buttons">
                  {['name', 'price', 'number', 'rating', 'height'].map((sortKey) => (
                    <Button
                      key={sortKey}
                      variant={orderby === sortKey ? 'primary' : 'outline-primary'}
                      onClick={() => handleOrderBy(sortKey)}
                      className="sort-btn"
                    >
                      {sortKey.charAt(0).toUpperCase() + sortKey.slice(1)}
                      {orderby === sortKey && (
                        <FontAwesomeIcon 
                          icon={getSortIcon()} 
                          className="ms-2" 
                        />
                      )}
                    </Button>
                  ))}
                </div>
              </Col>
              <Col lg={4}>
                <div className="collection-summary">
                  <Badge bg="info" className="summary-badge">
                    {filteredChildren.length} of {numberofitems} items
                  </Badge>
                  {searchTerm && (
                    <Badge bg="warning" className="summary-badge ms-2">
                      Filtered
                    </Badge>
                  )}
                </div>
              </Col>
            </Row>
          </div>
          {/* Pagination Controls */}
          <div className="pagination-controls">
            <Button 
              variant="outline-primary"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
              className="pagination-btn"
            >
              <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
              Previous
            </Button>
            
            <span className="pagination-info">
              Page {currentPage + 1} of {Math.ceil(filteredChildren.length / 4) || 1}
            </span>
            
            <Button 
              variant="outline-primary"
              onClick={handleNextPage}
              disabled={currentPage >= Math.ceil(filteredChildren.length / 4) - 1}
              className="pagination-btn"
            >
              Next
              <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
            </Button>
          </div>
          {/* Collection Grid */}
          <Row className="card-section-wrapper g-4">
            {filteredChildren.length === 0 ? (
              <Col xs={12}>
                <div className="empty-state">
                  <h4>No items found</h4>
                  <p>Try adjusting your search or filter criteria.</p>
                </div>
              </Col>
            ) : (
              filteredChildren.slice(currentPage * 4, currentPage * 4 + 4).map(
                (pokemon) => (
                  <Col 
                    xs={12} 
                    sm={6} 
                    md={4} 
                    lg={3} 
                    key={collection + "/" + pokemon.name}
                  >
                    <Card 
                      className="collection-item h-100" 
                      onClick={() => handleClick(pokemon.name, pokemon.collection)}
                    >
                      <Card.Header className="collection-card-header">
                        {renderCardHeader(pokemon.name)}
                      </Card.Header>
                      <Card.Body className={`collection-card-body ${screenSize === 1 ? 'small-screen' : ''}`}>
                        <div className="image-container">
                          <img 
                            className="image-small" 
                            src={`https://collectables.ashworthcloud.com/images/collection/${collection}/${pokemon.name}.jpg`} 
                            alt={pokemon.name}
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                            }}
                          />
                        </div>
                        <div className="item-details">
                          <p className="item-description">
                            {screenSize === 1 ? `£${pokemon.price}` : pokemon.description}
                          </p>
                          {screenSize > 1 && (
                            <div className="item-meta">
                              <Badge bg="success" className="price-badge">
                                £{pokemon.price}
                              </Badge>
                              {pokemon.rating && (
                                <Badge bg="warning" className="rating-badge ms-2">
                                  ★ {pokemon.rating}
                                </Badge>
                              )}
                            </div>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )
              )
            )}
          </Row>
          </div>

        </div>
      </Container>
    );
};

export default PokemonBinder;

